import styled, { css, keyframes } from 'styled-components';

import { AUTH_SHORTCUT_POPUP_ANIMATION_MS } from '@lib/core/service/consts';

import { Flexbox } from '@components/web/src/foundations/Flexbox/Flexbox';
import { COLORS } from '@components/web/src/styles';

const slideIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(100%);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const slideOut = keyframes`
  from {
    opacity: 1;
    transform: translateY(0);
  }

  to {
    opacity: 0;
    transform: translateY(100%);
  }
`;

export const AuthShortcutPopupContainer = styled(Flexbox)<{ $isClosing?: boolean }>`
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 10000;
  border-radius: 16px 16px 0 0;
  background-color: ${COLORS.warmGray[100]};
  box-shadow: 0 -4px 10px 0 rgba(0, 0, 0, 0.25);
  animation: ${({ $isClosing }) =>
    $isClosing
      ? css`
          ${slideOut} ${AUTH_SHORTCUT_POPUP_ANIMATION_MS}ms ease-out forwards
        `
      : css`
          ${slideIn} ${AUTH_SHORTCUT_POPUP_ANIMATION_MS}ms ease-out forwards
        `};
`;
